// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import 'lib-flexible/flexible';
import '../static/css/reset.css';
import '../src/utils/http.js'
Vue.config.productionTip = false
Vue.use(Vant);

// 判断是否是登录状态
router.beforeEach((to, from, next) => {
  let toRouter = {
    name: to.name
  }
  let fromRouter = {
    name: from.name
  }
  //路由发生变化修改页面title
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.matched.some(m => m.meta.requireAuth)) {
    if (localStorage.getItem('TOKEN') != null) {
      next()
    } else {
      next({
        path: '/'
      })
    }
  } else {
    next()
  }
});

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js